(function($) {

    $(document).ready(function() {
        $('.select-format select').change(function() {
            let odds_format = $(this).val();
            $('div.odds').each(function() {
                $('a', this).html($(this).attr('data-' + odds_format));
            });
        });

        $('.icon.sort-odds').click(function() {
            $(this).toggleClass('sorted');
            let tbody = $('table tbody', $(this).parents('.shortcode-odds'));
            let trs = tbody.find('tr');
            let column = parseInt($(this).attr('data-column'));
            trs.sort(function(a, b) {
                let odds_a = $('.odds', $($(a).find('td')[column])).attr('data-fractional').split('/');
                let odds_b = $('.odds', $($(b).find('td')[column])).attr('data-fractional').split('/');
                let value_a = parseFloat(odds_a[0]) / parseFloat(odds_a[1]);
                let value_b = parseFloat(odds_b[0]) / parseFloat(odds_b[1]);
                return (value_b - value_a);
            });
            let html = '';
            trs.each(function (a_index){
                html = html + '<tr>' + $(trs[a_index]).html() + '</tr>';
            });
            tbody.html(html);
        });
    });

})(jQuery);
